module.exports = __webpack_public_path__ + "static/media/upload_ar_field.f0c7ef33.png";